













import Vue, { PropType } from "vue";

type Platforms = "prebid" | "gam" | "tam";

export default Vue.extend({
  props: {
    platform: { type: String as PropType<Platforms>, required: true },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    content() {
      switch (this.platform) {
        case "prebid":
          return {
            title: "Prebid",
            text: [this.$t("home.tooltip.prebid.text1"), this.$t("home.tooltip.prebid.text2")],
            color: "green",
          };
        case "gam":
          return {
            title: "GAM",
            text: [this.$t("home.tooltip.gam.text1"), this.$t("home.tooltip.gam.text2")],
            color: "blue",
          };
        // TODO: TAM実装後に追加
        // case "tam":
        //   return {
        //     title: "TAM",
        //     text: "Hoge",
        //     color: "orange",
        //   };
        default:
          return {
            title: "",
            text: [] as Array<string>,
            color: "",
          };
      }
    },
  },
});
